(() => {
  if (window.TSSupportHubLoaded) return;

  window.TSSupportHubLoaded = true;

  const qsa = (root, selector) =>
    Array.from((root || document).querySelectorAll(selector));

  function eachMatch(root, selector, callback) {
    if (!root) return;

    if (root.matches && root.matches(selector)) callback(root);

    qsa(root, selector).forEach(callback);
  }

  function initPopular(section) {
    if (section.dataset.tsPopularInitialized === 'true') return;

    section.dataset.tsPopularInitialized = 'true';

    const rail = section.querySelector('[data-ts-popular-rail]');

    if (!rail) return;

    const navButtons = qsa(section, '[data-ts-popular-nav]');

    function updateNavVisibility() {
      const needsScroll = rail.scrollWidth > rail.clientWidth + 4;

      navButtons.forEach((button) => {
        button.style.visibility = needsScroll ? 'visible' : 'hidden';
        button.style.pointerEvents = needsScroll ? 'auto' : 'none';
        button.setAttribute(
          'aria-hidden',
          needsScroll ? 'false' : 'true'
        );
        button.tabIndex = needsScroll ? 0 : -1;
      });
    }

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const direction =
          button.dataset.tsPopularNav === 'next' ? 1 : -1;

        const card = rail.querySelector(
          '.ts-hub-popular__card'
        );

        const amount = card
          ? card.getBoundingClientRect().width + 15
          : rail.clientWidth * 0.9;

        rail.scrollBy({
          left: direction * amount,
          behavior: 'smooth',
        });
      });
    });

    requestAnimationFrame(updateNavVisibility);

    window.addEventListener(
      'resize',
      () => requestAnimationFrame(updateNavVisibility),
      { passive: true }
    );
  }

  function initShop(section) {
    if (section.dataset.tsShopInitialized === 'true') return;

    section.dataset.tsShopInitialized = 'true';

    const rail = section.querySelector('[data-ts-shop-rail]');

    if (!rail) return;

    const navButtons = qsa(section, '[data-ts-shop-nav]');

    function updateNavVisibility() {
      const needsScroll = rail.scrollWidth > rail.clientWidth + 4;

      navButtons.forEach((button) => {
        button.style.visibility = needsScroll
          ? 'visible'
          : 'hidden';

        button.style.pointerEvents = needsScroll
          ? 'auto'
          : 'none';

        button.setAttribute(
          'aria-hidden',
          needsScroll ? 'false' : 'true'
        );

        button.tabIndex = needsScroll ? 0 : -1;
      });
    }

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const direction =
          button.dataset.tsShopNav === 'next' ? 1 : -1;

        const card = rail.querySelector(
          '.ts-hub-shop__card'
        );

        const styles = getComputedStyle(rail);

        const gap =
          parseFloat(
            styles.columnGap || styles.gap || 16
          ) || 16;

        const amount = card
          ? card.getBoundingClientRect().width + gap
          : rail.clientWidth * 0.8;

        rail.scrollBy({
          left: direction * amount,
          behavior: 'smooth',
        });
      });
    });

    requestAnimationFrame(updateNavVisibility);

    window.addEventListener(
      'resize',
      () => requestAnimationFrame(updateNavVisibility),
      { passive: true }
    );
  }

  function initBrowser(section) {
    if (section.dataset.tsBrowserInitialized === 'true')
      return;

    section.dataset.tsBrowserInitialized = 'true';

    const tabs = qsa(section, '[data-ts-filter]');
    const devices = qsa(section, '[data-ts-device]');
    const resources = qsa(section, '[data-ts-resource]');

    const search = section.querySelector(
      '[data-ts-browser-search]'
    );

    const main = section.querySelector(
      '[data-ts-browser-main]'
    );

    const body = section.querySelector(
      '.ts-hub-browser__body'
    );

    const empty = section.querySelector(
      '[data-ts-browser-empty]'
    );

    const viewAllWrap = section.querySelector(
      '[data-ts-browser-view-all]'
    );

    const viewAllLink = section.querySelector(
      '[data-ts-browser-view-all-link]'
    );

    const selectedImage = section.querySelector(
      '[data-ts-selected-image]'
    );

    const selectedTitle = section.querySelector(
      '[data-ts-selected-title]'
    );

    const selectedSub = section.querySelector(
      '[data-ts-selected-sub]'
    );

    const selectedLink = section.querySelector(
      '[data-ts-selected-link]'
    );

    const selectedLinkLabel = section.querySelector(
      '[data-ts-selected-link-label]'
    );

    const mobileSelectedTitle = section.querySelector(
      '[data-ts-mobile-selected-title]'
    );

    const mobileMedia = window.matchMedia(
      '(max-width: 749px)'
    );

    const maxVisible = Math.max(
      1,
      parseInt(section.dataset.maxVisible || '10', 10) ||
        10
    );

    let activeFilter =
      (
        tabs.find((tab) =>
          tab.classList.contains('is-active')
        ) || tabs[0]
      )?.dataset.tsFilter || 'device';

    let mobileExpanded = false;

    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase();
    }

    function resourceHasTag(resource, wantedTag) {
      const wanted = normalize(wantedTag);

      if (!wanted) return false;

      return normalize(resource.dataset.hubTags)
        .split('|')
        .map((tag) => tag.trim())
        .filter(Boolean)
        .includes(wanted);
    }

    function restoreMainPosition() {
      if (!main || !body) return;

      if (main.parentElement !== body) {
        body.appendChild(main);
      }
    }

    function syncMobileLayout(activeDevice) {
      if (!main) return;

      const isDevice = activeFilter === 'device';

      if (!mobileMedia.matches || !isDevice) {
        restoreMainPosition();

        main.classList.remove(
          'is-mobile-collapsed'
        );

        section.classList.remove(
          'is-mobile-device-expanded'
        );

        return;
      }

      if (!mobileExpanded || !activeDevice) {
        restoreMainPosition();

        main.classList.add(
          'is-mobile-collapsed'
        );

        section.classList.remove(
          'is-mobile-device-expanded'
        );

        return;
      }

      activeDevice.insertAdjacentElement(
        'afterend',
        main
      );

      main.classList.remove(
        'is-mobile-collapsed'
      );

      section.classList.add(
        'is-mobile-device-expanded'
      );
    }

    function setSelectedDevice(
      button,
      options = {}
    ) {
      if (!button) return;

      devices.forEach((item) =>
        item.classList.toggle(
          'is-active',
          item === button
        )
      );

      if (selectedTitle) {
        selectedTitle.textContent =
          button.dataset.title || '';
      }

      if (selectedSub) {
        selectedSub.textContent =
          button.dataset.subtitle || '';
      }

      if (mobileSelectedTitle) {
        mobileSelectedTitle.textContent =
          button.dataset.title || '';
      }

      if (selectedImage) {
        selectedImage.src =
          button.dataset.image || '';

        selectedImage.alt =
          button.dataset.imageAlt ||
          button.dataset.title ||
          '';
      }

      if (selectedLink) {
        const href =
          button.dataset.link || '#';

        selectedLink.setAttribute(
          'href',
          href
        );

        selectedLink.style.display =
          !href || href === '#' ? 'none' : '';
      }

      if (selectedLinkLabel) {
        selectedLinkLabel.textContent =
          button.dataset.linkLabel ||
          section.dataset.defaultProductLabel ||
          '';
      }

      if (
        options.expandOnMobile &&
        mobileMedia.matches
      ) {
        mobileExpanded = true;
      }

      syncMobileLayout(button);
    }

    function getActiveDevice() {
      return (
        devices.find((device) =>
          device.classList.contains('is-active')
        ) ||
        devices[0] ||
        null
      );
    }

    function updateViewAll(
      totalMatches,
      isDevice,
      currentDevice,
      query
    ) {
      if (!viewAllWrap || !viewAllLink) return;

      const shouldShow =
        totalMatches > maxVisible;

      viewAllWrap.hidden = !shouldShow;

      if (!shouldShow) return;

      const base =
        viewAllLink.dataset.baseUrl ||
        viewAllLink.getAttribute('href') ||
        '/pages/help-guides';

      let url;

      try {
        url = new URL(
          base,
          window.location.origin
        );
      } catch (e) {
        url = new URL(
          '/pages/help-guides',
          window.location.origin
        );
      }

      url.search = '';

      if (isDevice && currentDevice) {
        const deviceKey = normalize(
          currentDevice.dataset.articleTag
        ).replace(/^hub-device:/, '');

        if (deviceKey) {
          url.searchParams.set(
            'device',
            deviceKey
          );
        }
      } else {
        url.searchParams.set(
          'tab',
          normalize(activeFilter)
        );
      }

      if (query) {
        url.searchParams.set('q', query);
      }

      viewAllLink.setAttribute(
        'href',
        url.pathname + url.search
      );
    }

    function apply() {
      const query = normalize(
        search?.value
      );

      const isDevice =
        activeFilter === 'device';

      section.classList.toggle(
        'is-non-device',
        !isDevice
      );

      devices.forEach((device) => {
        device.hidden = !isDevice;
      });

      let currentDevice = null;
      let requiredTag = '';

      if (isDevice) {
        currentDevice = getActiveDevice();

        if (currentDevice) {
          setSelectedDevice(currentDevice);

          requiredTag = normalize(
            currentDevice.dataset.articleTag
          );
        }
      } else {
        mobileExpanded = false;

        requiredTag =
          `hub-tab:${normalize(activeFilter)}`;

        syncMobileLayout(null);
      }

      const matches = resources.filter(
        (resource) => {
          const matchesTag = resourceHasTag(
            resource,
            requiredTag
          );

          const haystack = normalize(
            resource.dataset.search ||
              resource.textContent
          );

          const matchesQuery =
            !query ||
            haystack.includes(query);

          return (
            matchesTag &&
            matchesQuery
          );
        }
      );

      resources.forEach((resource) => {
        resource.hidden = true;
      });

      matches
        .slice(0, maxVisible)
        .forEach((resource) => {
          resource.hidden = false;
        });

      if (empty) {
        empty.style.display =
          matches.length === 0
            ? 'block'
            : 'none';
      }

      updateViewAll(
        matches.length,
        isDevice,
        currentDevice,
        query
      );

      if (main) {
        main.hidden = false;
      }

      if (isDevice) {
        syncMobileLayout(
          currentDevice
        );
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activeFilter =
          tab.dataset.tsFilter ||
          'device';

        mobileExpanded = false;

        tabs.forEach((item) => {
          const isActive =
            item === tab;

          item.classList.toggle(
            'is-active',
            isActive
          );

          item.setAttribute(
            'aria-selected',
            isActive
              ? 'true'
              : 'false'
          );
        });

        apply();
      });
    });

    devices.forEach((device) => {
      device.addEventListener(
        'click',
        () => {
          const isSameOpenDevice =
            mobileMedia.matches &&
            mobileExpanded &&
            device.classList.contains(
              'is-active'
            ) &&
            main?.previousElementSibling ===
              device;

          if (isSameOpenDevice) {
            mobileExpanded = false;

            syncMobileLayout(
              device
            );

            return;
          }

          setSelectedDevice(device, {
            expandOnMobile: true,
          });

          apply();
        }
      );
    });

    search?.addEventListener(
      'input',
      apply
    );

    const handleViewportChange = () => {
      const current = getActiveDevice();

      if (!mobileMedia.matches) {
        mobileExpanded = false;
      }

      syncMobileLayout(current);
    };

    if (
      typeof mobileMedia.addEventListener ===
      'function'
    ) {
      mobileMedia.addEventListener(
        'change',
        handleViewportChange
      );
    } else if (
      typeof mobileMedia.addListener ===
      'function'
    ) {
      mobileMedia.addListener(
        handleViewportChange
      );
    }

    apply();
  }

  function initAllArticles(section) {
    if (
      section.dataset
        .tsAllArticlesInitialized === 'true'
    ) {
      return;
    }

    section.dataset.tsAllArticlesInitialized =
      'true';

    const tabs = qsa(
      section,
      '[data-ts-all-tab]'
    );

    const devicePills = qsa(
      section,
      '[data-ts-all-device]'
    );

    const deviceRow = section.querySelector(
      '[data-ts-all-device-row]'
    );

    const search = section.querySelector(
      '[data-ts-all-search]'
    );

    const resources = qsa(
      section,
      '[data-ts-all-resource]'
    );

    const empty = section.querySelector(
      '[data-ts-all-empty]'
    );

    const count = section.querySelector(
      '[data-ts-all-count]'
    );

    const loadMore = section.querySelector(
      '[data-ts-all-load-more]'
    );

    const pageSize = Math.max(
      1,
      parseInt(
        section.dataset.pageSize ||
          '24',
        10
      ) || 24
    );

    let activeTab = 'all';
    let activeDevice = 'dash-cams';
    let visibleLimit = pageSize;

    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase();
    }

    function resourceHasTag(
      resource,
      wantedTag
    ) {
      const wanted =
        normalize(wantedTag);

      if (!wanted) return false;

      return normalize(
        resource.dataset.hubTags
      )
        .split('|')
        .map((tag) => tag.trim())
        .filter(Boolean)
        .includes(wanted);
    }

    function setActiveTab(tabKey) {
      activeTab =
        tabKey || 'device';

      tabs.forEach((button) => {
        const active =
          button.dataset.tsAllTab ===
          activeTab;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-selected',
          active
            ? 'true'
            : 'false'
        );
      });

      if (deviceRow) {
        deviceRow.hidden =
          activeTab !== 'device';
      }
    }

    function setActiveDevice(
      deviceKey
    ) {
      activeDevice =
        deviceKey || 'dash-cams';

      devicePills.forEach(
        (button) => {
          const active =
            button.dataset.tsAllDevice ===
            activeDevice;

          button.classList.toggle(
            'is-active',
            active
          );

          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );
        }
      );
    }

    function updateUrl(query) {
      const url = new URL(
        window.location.href
      );

      url.searchParams.delete('tab');
      url.searchParams.delete('device');
      url.searchParams.delete('q');

      if (activeTab === 'device') {
        url.searchParams.set(
          'device',
          activeDevice
        );
      } else if (
        activeTab !== 'all'
      ) {
        url.searchParams.set(
          'tab',
          activeTab
        );
      }

      if (query) {
        url.searchParams.set(
          'q',
          query
        );
      }

      window.history.replaceState(
        {},
        '',
        url.pathname + url.search
      );
    }

    function apply(options = {}) {
      const query = normalize(
        search?.value
      );

      const showAll =
        activeTab === 'all';

      if (
        options.resetLimit !== false
      ) {
        visibleLimit =
          showAll && !query
            ? Number.MAX_SAFE_INTEGER
            : pageSize;
      }

      const requiredTag =
        activeTab === 'device'
          ? `hub-device:${activeDevice}`
          : `hub-tab:${activeTab}`;

      const matches = resources.filter(
        (resource) => {
          const matchesTag =
            showAll
              ? true
              : resourceHasTag(
                  resource,
                  requiredTag
                );

          const haystack = normalize(
            resource.dataset.search ||
              resource.textContent
          );

          const matchesQuery =
            !query ||
            haystack.includes(query);

          return (
            matchesTag &&
            matchesQuery
          );
        }
      );

      resources.forEach(
        (resource) => {
          resource.hidden = true;
        }
      );

      matches
        .slice(0, visibleLimit)
        .forEach((resource) => {
          resource.hidden = false;
        });

      if (empty) {
        empty.hidden =
          matches.length !== 0;
      }

      if (count) {
        const visibleCount =
          Math.min(
            visibleLimit,
            matches.length
          );

        count.textContent =
          matches.length === 0
            ? '0 guides'
            : visibleCount >=
                matches.length
              ? `${matches.length} guides`
              : `${visibleCount} of ${matches.length} guides`;
      }

      if (loadMore) {
        loadMore.hidden =
          matches.length <=
          visibleLimit;
      }

      if (
        options.updateUrl !== false
      ) {
        updateUrl(query);
      }
    }

    tabs.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          setActiveTab(
            button.dataset.tsAllTab ||
              'device'
          );

          apply();
        }
      );
    });

    devicePills.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            setActiveTab('device');

            setActiveDevice(
              button.dataset
                .tsAllDevice ||
                'dash-cams'
            );

            apply();
          }
        );
      }
    );

    search?.addEventListener(
      'input',
      apply
    );

    loadMore?.addEventListener(
      'click',
      () => {
        visibleLimit += pageSize;

        apply({
          resetLimit: false,
        });
      }
    );

    const params =
      new URLSearchParams(
        window.location.search
      );

    const paramDevice = normalize(
      params.get('device')
    );

    const paramTab = normalize(
      params.get('tab')
    );

    const paramQuery =
      params.get('q') || '';

    const validDevices =
      devicePills
        .map((button) =>
          normalize(
            button.dataset
              .tsAllDevice
          )
        )
        .filter(Boolean);

    if (
      paramDevice &&
      validDevices.includes(paramDevice)
    ) {
      setActiveTab('device');

      setActiveDevice(paramDevice);
    } else if (
      [
        'buying-comparison',
        'troubleshooting',
        'support',
        'bulk-purchase',
      ].includes(paramTab)
    ) {
      setActiveTab(paramTab);
    } else {
      setActiveTab('all');
    }

    if (
      search &&
      paramQuery
    ) {
      search.value =
        paramQuery;
    }

    apply({
      updateUrl: false,
    });
  }

  function init(root = document) {
    eachMatch(
      root,
      '[data-ts-popular]',
      initPopular
    );

    eachMatch(
      root,
      '[data-ts-shop]',
      initShop
    );

    eachMatch(
      root,
      '[data-ts-browser]',
      initBrowser
    );

    eachMatch(
      root,
      '[data-ts-all-articles]',
      initAllArticles
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      init(event.target)
  );
})();